import { css } from "@emotion/css";
import { ReturnOrderStatus } from "../constants/StatusProvider";

export const profileFooterStyle = css({
  position: "fixed",
  bottom: 0,
  left: 0,
  boxShadow: "0px 2px 16px 0px #0B0C0C1A",
  zIndex: 30,
  padding: "12px 16px"
});

export const borderStyle = css({
  "& > :not(:last-child)": {
    marginBottom: "0px !important",
    borderBottom: "1px solid #BBC0C1",
    wordBreak: "break-word",
  },
});

export const maskLoaderStyle = css({
  position: "fixed",
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  width: "100%",
  height:"100vh",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  zIndex:"55",
});

export const buttonStyle = css({
  backgroundColor: "white",
  ":hover": {
    boxShadow: "none",
    backgroundColor: "white"
  }
});

export const layoutDescriptionTextStyle = css({
  color: "#00A69A !important",
  fontWeight: "700 !important",
});

export interface IReturnOrderCountItem {
  id: ReturnOrderStatus;
  title: string;
  textColor: string;
  backgroundColor: string;
}

export const ReturnOrderCountList: IReturnOrderCountItem[] = [
  {
    id: ReturnOrderStatus.REQUESTED,
    title: "Pending",
    textColor: "#BF8E00",
    backgroundColor: "#FFF4D9",
  },
  {
    id: ReturnOrderStatus.ACCEPTED,
    title: "Approved",
    textColor: "#077398",
    backgroundColor: "#E5F6FB",
  },
  {
    id: ReturnOrderStatus.COMPLETED,
    title: "Completed",
    textColor: "#348118",
    backgroundColor: "#D6ECC9",
  },
  {
    id: ReturnOrderStatus.REJECTED,
    title: "Rejected",
    textColor: "#DE1B1B",
    backgroundColor: "#FFD9CF",
  },
];

export const StatusToken = (textColor: string, backgroundColor: string) => {
  return {
    textColorPrimary: textColor,
    boxBackgroundColorFill: backgroundColor,
  };
};